var _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flag 1",
    clipPath: "url(#clip0_1626_78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1626_78",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3261",
    d: "M15.4992 7.99968C15.4995 8.98448 15.3057 9.95967 14.929 10.8696C14.5522 11.7795 14 12.6062 13.3037 13.3027C12.6074 13.9991 11.7807 14.5515 10.8709 14.9285C9.96112 15.3054 8.98597 15.4994 8.00118 15.4994C7.01638 15.4994 6.04123 15.3054 5.13142 14.9285C4.22161 14.5515 3.39495 13.9991 2.69867 13.3027C2.00239 12.6062 1.45012 11.7795 1.07341 10.8696C0.696688 9.95967 0.502901 8.98448 0.503113 7.99968C0.502901 7.01489 0.696688 6.03969 1.07341 5.1298C1.45012 4.21991 2.00239 3.39314 2.69867 2.6967C3.39495 2.00027 4.22161 1.44783 5.13142 1.07091C6.04123 0.693997 7.01638 0.5 8.00118 0.5C8.98597 0.5 9.96112 0.693997 10.8709 1.07091C11.7807 1.44783 12.6074 2.00027 13.3037 2.6967C14 3.39314 14.5522 4.21991 14.929 5.1298C15.3057 6.03969 15.4995 7.01489 15.4992 7.99968Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1626_78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18829",
    d: "M-3.25153 12.0373H19.2485V10.8828H-3.25153V12.0373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18831",
    d: "M-3.25153 10.8825H19.2485V9.72852H-3.25153V10.8825Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18833",
    d: "M-3.25153 14.3454H19.2485V13.1914H-3.25153V14.3454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18835",
    d: "M-3.25153 15.5001H19.2485V14.3457H-3.25153V15.5001Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18837",
    d: "M-3.25153 13.1902H19.2485V12.0371H-3.25153V13.1902Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18839",
    d: "M-3.25153 9.67461H19.2485V8.52148H-3.25153V9.67461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18841",
    d: "M-3.25153 6.26836H19.2485V5.11523H-3.25153V6.26836Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18843",
    d: "M-3.25153 2.80678H19.2485V1.65234H-3.25153V2.80678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18845",
    d: "M-3.25153 3.96065H19.2485V2.80664H-3.25153V3.96065Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18847",
    d: "M-3.25153 8.5772H19.2485V7.42188H-3.25153V8.5772Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18849",
    d: "M-3.25153 1.65181H19.2485V0.5H-3.25153V1.65181Z",
    fill: "#E74C3C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path18851",
    d: "M-3.25153 5.11539H19.2485V3.96094H-3.25153V5.11539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18853",
    d: "M-3.25153 7.4207H19.2485V6.26758H-3.25153V7.4207Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1626_78",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3271",
    d: "M15.5018 7.99931C15.502 8.98405 15.3083 9.9592 14.9316 10.869C14.5549 11.7789 14.0026 12.6056 13.3064 13.302C12.6101 13.9984 11.7835 14.5508 10.8737 14.9277C9.96398 15.3046 8.98887 15.4986 8.00413 15.4986C7.01938 15.4986 6.04428 15.3046 5.13451 14.9277C4.22475 14.5508 3.39814 13.9984 2.70189 13.302C2.00564 12.6056 1.4534 11.7789 1.0767 10.869C0.700004 9.9592 0.506227 8.98405 0.506439 7.99931C0.506227 7.01456 0.700004 6.03942 1.0767 5.12957C1.4534 4.21972 2.00564 3.39299 2.70189 2.69659C3.39814 2.0002 4.22475 1.44778 5.13451 1.07088C6.04428 0.693987 7.01938 0.5 8.00413 0.5C8.98887 0.5 9.96398 0.693987 10.8737 1.07088C11.7835 1.44778 12.6101 2.0002 13.3064 2.69659C14.0026 3.39299 14.5549 4.21972 14.9316 5.12957C15.3083 6.03942 15.502 7.01456 15.5018 7.99931Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1626_78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3263",
    d: "M1.52357 0.5C0.956093 0.5 0.499603 1.04532 0.499603 1.72173V9.79339H7.99961V0.5H1.52357Z",
    fill: "#3C3B6E"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g3273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3275",
    d: "M4.10541 4.19141C3.24871 4.19141 2.55338 5.01464 2.55338 6.02891C2.55338 7.04317 3.24871 7.86641 4.10541 7.86641C4.41492 7.86641 4.7033 7.75882 4.9455 7.57373C4.80446 7.63155 4.65309 7.66317 4.49551 7.66317C3.73585 7.66317 3.11932 6.93324 3.11932 6.03386C3.11932 5.13448 3.73585 4.40455 4.49551 4.40455C4.66339 4.40455 4.8242 4.44017 4.97299 4.50541C4.72528 4.30723 4.42667 4.19141 4.10541 4.19141Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3277",
    d: "M6.68023 6.98528L6.02636 6.58019L6.21969 7.40924L5.78235 6.71573L5.64591 7.55982L5.51172 6.71525L5.07253 7.40719L5.26807 6.57883L4.61312 6.98158L5.09966 6.3335L4.35867 6.36729L5.03984 6.02785L4.35958 5.68598L5.10047 5.72241L4.61566 5.0726L5.26953 5.47769L5.0762 4.64863L5.51354 5.34214L5.64999 4.49805L5.78418 5.34262L6.22336 4.65068L6.02783 5.47904L6.68277 5.07629L6.19623 5.72437L6.93722 5.69058L6.25605 6.03002L6.93631 6.37189L6.19542 6.33546L6.68023 6.98528Z",
    fill: "#FFCC00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag1);
export default __webpack_public_path__ + "static/media/flag 1.a4525276afeae57a51eb9a0173e0d34d.svg";
export { ForwardRef as ReactComponent };